"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AirwebTicketLegacyNetworksService = void 0;
class AirwebTicketLegacyNetworksService {
    constructor(client) {
        this.client = client;
    }
    async getNetworks(options = {}) {
        const response = (await this.client.http
            .get('Networks/getNetworks.json', options)
            .catch(this.handleError));
        return response.data.networks;
    }
    async getNetworkConfiguration(networkIdOrOrigin, options = {}) {
        const identifier = Number.isInteger(+networkIdOrOrigin) ? 'id' : 'domain';
        const response = (await this.client.http
            .get('Networks/getNetworkConfiguration.json', Object.assign({ params: { [identifier]: networkIdOrOrigin } }, options))
            .catch(this.handleError));
        return response.data;
    }
    async getNetwork(networkId, options = {}) {
        const networks = await this.getNetworks(options);
        const network = networks.find((network) => {
            return String(network.networkId) === String(networkId);
        });
        return network;
    }
    async getProfileStatuses(networkId, options) {
        const response = (await this.client.http
            .get('Networks/getProfileStatus.json', Object.assign(Object.assign({}, options), { params: { network_id: networkId } }))
            .catch(this.handleError));
        return response.data.status;
    }
    async getNetworkStops(networkId, options) {
        const response = (await this.client.http
            .get('Networks/getProfileStatus.json', Object.assign(Object.assign({}, options), { params: { network_id: networkId } }))
            .catch(this.handleError));
        return response.data.stops;
    }
    async getSchoolConfiguration(networkId, options = {}) {
        const response = await this.client.http.get('Networks/getSchoolConfiguration', Object.assign({ params: { networkId } }, options));
        return response.data;
    }
    async getAuthenticationConfiguration(networkId, options = {}) {
        const { data } = await this.client.http.get('Networks/getAuthenticationConfiguration', Object.assign({ params: { networkId } }, options));
        return data;
    }
    async getCollectSites(networkId, options = {}) {
        const { data } = await this.client.http.get('Networks/collectSites', Object.assign({ params: {
                id: networkId,
            } }, options));
        if (options.sortByIndex) {
            return data.collectSites.sort((agencyA, agencyB) => {
                return agencyA.index - agencyB.index;
            });
        }
        return data.collectSites;
    }
    handleError(error) {
        throw error;
    }
}
exports.AirwebTicketLegacyNetworksService = AirwebTicketLegacyNetworksService;
//# sourceMappingURL=networks.service.js.map